/* Opinabile · Continuum: area aziende sbloccabile con partita IVA e comparsa morbida delle sezioni.
   Lo sblocco è un filtro di cortesia, non una protezione: i contenuti sono comunque nella pagina. */
(function () {
  var CHIAVE = 'opinabile-piva';
  var html = document.documentElement;

  // Partita IVA italiana: 11 cifre con cifra di controllo (algoritmo dell'Agenzia delle Entrate).
  function pivaValida(valore) {
    var v = String(valore || '').replace(/\s+/g, '').toUpperCase().replace(/^IT/, '');
    if (!/^\d{11}$/.test(v) || /^0+$/.test(v)) return null;
    var somma = 0;
    for (var i = 0; i < 10; i++) {
      var cifra = +v.charAt(i);
      if (i % 2 === 1) {
        cifra *= 2;
        if (cifra > 9) cifra -= 9;
      }
      somma += cifra;
    }
    var controllo = (10 - somma % 10) % 10;
    return controllo === +v.charAt(10) ? v : null;
  }

  function sblocca(piva) {
    html.classList.add('cn-b2b-on');
    try { sessionStorage.setItem(CHIAVE, piva); } catch (e) {}
    document.querySelectorAll('[data-cn-piva-campo]').forEach(function (campo) {
      if (!campo.value) campo.value = piva;
    });
  }

  function blocca() {
    html.classList.remove('cn-b2b-on');
    try { sessionStorage.removeItem(CHIAVE); } catch (e) {}
  }

  function avvia() {
    var salvata = null;
    try { salvata = pivaValida(sessionStorage.getItem(CHIAVE)); } catch (e) {}
    if (salvata) sblocca(salvata);

    document.querySelectorAll('[data-cn-piva-form]').forEach(function (form) {
      var campo = form.querySelector('input');
      var messaggio = form.querySelector('[data-cn-piva-msg]');
      form.addEventListener('submit', function (evento) {
        evento.preventDefault();
        var piva = pivaValida(campo.value);
        if (!piva) {
          messaggio.textContent = form.getAttribute('data-errore');
          campo.focus();
          return;
        }
        messaggio.textContent = '';
        sblocca(piva);
        var primo = document.querySelector('.cn-locked');
        if (primo) primo.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    document.querySelectorAll('[data-cn-piva-reset]').forEach(function (link) {
      link.addEventListener('click', function (evento) {
        evento.preventDefault();
        blocca();
      });
    });

    var sezioni = document.querySelectorAll('.cn-reveal');
    if (!('IntersectionObserver' in window)) {
      sezioni.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var osservatore = new IntersectionObserver(function (voci) {
      voci.forEach(function (voce) {
        if (voce.isIntersecting) {
          voce.target.classList.add('is-in');
          osservatore.unobserve(voce.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    sezioni.forEach(function (el) { osservatore.observe(el); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia);
  else avvia();
})();